module.exports = __webpack_public_path__ + "img/phone.9c3a423a.png";